<template>
  <a
    v-bind="{'xlink:href': link }"
  >
    <polygon
      v-if="shape.polygon"
      :key="'polygon-' + shape.id"
      :points="shape.polygon"
      :class="css"
      @mouseenter="toggleFocus(true)"
      @mouseout="toggleFocus(false)"
      @click="updateRouter"
      class="c-illustration__shape"
    />
    <path
      v-else
      :key="'path-' + shape.id"
      :d="shape.path"
      :class="css"
      @mouseenter="toggleFocus(true)"
      @mouseout="toggleFocus(false)"
      @click="updateRouter"
      class="c-illustration__shape"
    />
  </a>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

// VUEX Models
import Availability from '@/models/Availability';
import Section from '@/models/Section';
import Illustration from '@/models/Illustration';
import Residence from '@/models/Residence';
import Shape from '@/models/Shape';

export default {
  name: 'Shape',
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      required: true,
      type: String,
    },
  },
  data: function() {
    return {
      hasFocus: false,
    };
  },
  computed: {
    shape() {
      return Shape.find(this.id);
    },
    residence() {
      if (this.type === 'residences') {
        return Residence.query()
          .with('availability')
          .find(this.shape.shapeable_id);
      } else {
        return { availability: false, id: false, };
      }
    },
    section() {
      if (this.type === 'sections') {
        return Section.query()
          .with('availability')
          .find(this.shape.shapeable_id);
      } else {
        return { availability: false, id: false, };
      }
    },
    availability() {
      if (this.type === 'residences') {
        return Availability.find(this.residence.availability_id);
      } else if (this.type === 'sections') {
        return Availability.find(this.section.availability_id);
      } else {
        return false;
      }
    },
    css() {
      const availability = this.availability;
      let classes = '';
      if (availability !== false) {
        classes += 'is-' + availability.slug;
      } else {
        classes += 'is-none';
      }
      if (this.hasFocus === true) {
        classes += ' has-focus';
      }
      if (this.type === 'sections') {
        classes += ' is-section';
      } else if (this.type === 'residences') {
        classes += ' is-residence';
      }
      return classes;
    },
    link() {
      if (this.section.url) {
        return this.section.url;
      } else {
        return false;
      }
    },
  },
  created() {
    if (this.type === 'residences') {
      EventBus.$on('residence-focus', focus => {
        if (focus.id === this.residence.id) {
          this.hasFocus = focus.hasFocus;
        }
      });
    } else if (this.type === 'sections') {
      EventBus.$on('section-focus', focus => {
        if (focus.id === this.section.id) {
          this.hasFocus = focus.hasFocus;
        }
      });
    }
  },
  methods: {
    toggleFocus(focus) {
      if (this.type === 'residences') {
        EventBus.$emit('residence-focus', {
          hasFocus: focus,
          id: this.residence.id,
          name: this.residence.name,
          illustrationIds: [],
        });
      } else if (this.type === 'sections') {
        EventBus.$emit('section-focus', {
          hasFocus: focus,
          id: this.section.id,
          name: this.section.name,
        });
      }
      if (this.type === 'residences') {
        this.scrollResidenceIntoView(this.residence.slug);
      }
    },
    updateRouter() {
      this.toggleFocus(false);
      if (this.type === 'residences') {
        this.$router.push({
          name: 'bolig',
          params: { slug: this.residence.slug, },
        });
      } else {
        if (this.link === false) {
          this.updateSelectedSection();
        }
      }
    },
    scrollResidenceIntoView(element) {
      const residence = document.getElementById(element);
      if (residence) {
        const residenceList = document.getElementById('residenceList');
        const offset = residence.offsetTop;
        residenceList.scrollTo({ top: offset, behavior: 'smooth', });
      }
    },
    updateSelectedSection() {
      Section.commit(state => {
        state.selectedSection = this.shape.shapeable_id;
      });
      Illustration.commit(state => {
        state.currentSection = this.shape.shapeable_id;
      });
      localStorage.setItem('selectedSection', this.shape.shapeable_id);
    },
  },
};
</script>

